import React, { useState } from "react";
import Style from "./NavBar.module.css";
import { Link } from "react-router-dom";
import Social from "../socialmedia/Social";

const iconInitialState = {
  home: true,
  about: false,
  skills: false,
  projects: false,
  contact: false,
};

const active = `${Style.active}`;
function NavigationBar() {
  const [showHome, setShowHome] = useState(true);
  const [showAbout, setShowAbout] = useState(true);
  const [showSkills, setShowSkills] = useState(true);
  const [showProjects, setShowProjects] = useState(true);
  const [showContact, setShowContact] = useState(true);

  const [showIcon, setShowIcon] = useState(iconInitialState);

  const handleHome = () => {
    setShowIcon({
      home: true,
      about: false,
      skills: false,
      projects: false,
      contact: false,
    });
  };
  const handleAbout = () => {
    setShowIcon({
      home: false,
      about: true,
      skills: false,
      projects: false,
      contact: false,
    });
  };

  const handleSkills = () => {
    setShowIcon({
      home: false,
      about: false,
      skills: true,
      projects: false,
      contact: false,
    });
  };
  const handleProjects = () => {
    setShowIcon({
      home: false,
      about: false,
      skills: false,
      projects: true,
      contact: false,
    });
  };
  const handleContact = () => {
    setShowIcon({
      home: false,
      about: false,
      skills: false,
      projects: false,
      contact: true,
    });
  };
  return (
    <div className={Style.navbackground}>
      <div className={Style.sec1}>
        <Link onClick={handleHome} to={"/home"} className={Style.navlink}>
          <div className={Style.fontshadow}>D</div>
          <div className={Style.initialname}>Dayo</div>
        </Link>
      </div>
      <div className={Style.sec2}>
        <div
          onMouseLeave={() => setShowHome(!showHome)}
          onMouseEnter={() => setShowHome(!showHome)}
          className={Style.icon}
        >
          <div onClick={handleHome} className={showIcon.home && active}>
            <Link to={"/home"} className={Style.navlink}>
              <i className={showHome && "fa fa-home"} aria-hidden="true"></i>
              {!showHome && <span>Home</span>}
            </Link>
          </div>
        </div>
        <div
          onMouseLeave={() => setShowAbout(!showAbout)}
          onMouseEnter={() => setShowAbout(!showAbout)}
          className={Style.icon}
        >
          <div
            onClick={handleAbout}
            // onMouseLeave={handleHome}
            // onMouseEnter={handleAbout}
            className={showIcon.about && active}
          >
            <Link onClick={handleAbout} to={"/about"} className={Style.navlink}>
              <i className={showAbout && "fa fa-user"} aria-hidden="true"></i>
              {!showAbout && <span>About</span>}
            </Link>
          </div>
        </div>
        <div
          onMouseLeave={() => setShowSkills(!showSkills)}
          onMouseEnter={() => setShowSkills(!showSkills)}
          className={Style.icon}
        >
          <div onClick={handleSkills} className={showIcon.skills && active}>
            <Link
              onClick={handleAbout}
              to={"/skills"}
              className={Style.navlink}
            >
              <i class={showSkills && "fa fa-cog"} aria-hidden="true"></i>
              {!showSkills && <span>Skills</span>}
            </Link>
          </div>
        </div>
        <div onClick={handleProjects} className={showIcon.projects && active}>
          <div
            onMouseLeave={() => setShowProjects(!showProjects)}
            onMouseEnter={() => setShowProjects(!showProjects)}
            className={Style.icon}
          >
            <Link
              onClick={handleAbout}
              to={"/projects"}
              className={Style.navlink}
            >
              <i className={showProjects && "fa fa-eye"} aria-hidden="true"></i>
              {!showProjects && <span>Projects</span>}
            </Link>
          </div>
        </div>
        <div onClick={handleContact} className={showIcon.contact && active}>
          <div
            onMouseLeave={() => setShowContact(!showContact)}
            onMouseEnter={() => setShowContact(!showContact)}
            className={Style.icon}
          >
            <Link
              onClick={handleAbout}
              to={"/contact"}
              className={Style.navlink}
            >
              <i
                className={showContact && "fa fa-envelope"}
                aria-hidden="true"
              ></i>
              {!showContact && <span>Contact</span>}
            </Link>
          </div>
        </div>
      </div>
      <div style={{ color: "white" }}>
        <Social />
      </div>
    </div>
  );
}

export default NavigationBar;
